import React from 'react';

// Hooks
import { useWorkspace } from 'Shared/utils/hooks/use-workspace';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

// Components
import { WpAvatarGroup } from 'Wpds/components/avatar';
import WpIcon from 'Wpds/components/icon/WpIcon';
import { useTooltip, WpTooltipOverlay } from 'Wpds/components/tooltip';

// Styles
import './WorkspacePresenceUsers.scss';

const WorkspacePresenceUsers = () => {
  const { workspace } = useWorkspace();
  const { id: currentUserId } = useCurrentUser();
  const presenceData = workspace.presenceData;

  const users = workspace.users || [];
  const presenceUsers = users
    .map(user => ({ ...user, disabled: !presenceData[Number(user.id)]?.active }))
    .sort(function (a, b) {
      const textA = a.displayName.toUpperCase();
      const textB = b.displayName.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    })
    .sort((a, b) => (Number(a.disabled) > Number(b.disabled) ? 1 : -1));

  // Ensure the current logged in user is always first in the list
  const currentUserObject = presenceUsers.filter(user => user.id === currentUserId);
  const sortedUsers = [...currentUserObject, ...presenceUsers.filter(user => user.id !== currentUserId)];

  const baseClassName = 'WorkspacePresenceUsers';

  const UserTooltip = ({ children, user }) => {
    const tooltip = useTooltip();

    const isCurrentlyViewing = presenceData[Number(user.id)]?.active;

    return (
      <>
        <div ref={tooltip.targetRef}>{children}</div>
        <WpTooltipOverlay context={tooltip}>
          <div className={`${baseClassName}__tooltip`}>
            <p className={`${baseClassName}__tooltip__name`}>{user.fullName}</p>
            <p className={`${baseClassName}__tooltip__email`}>{user.email}</p>
          </div>
          <div className={`${baseClassName}__tooltip__status`}>
            {isCurrentlyViewing ? (
              <>
                <WpIcon name="eye" />{' '}
                <span className={`${baseClassName}__tooltip__status__label`}>Currently viewing</span>
              </>
            ) : (
              <>
                <WpIcon name="eye-slash" />
                <span className={`${baseClassName}__tooltip__status__label`}>Not viewing</span>
              </>
            )}
          </div>
        </WpTooltipOverlay>
      </>
    );
  };

  return (
    <WpAvatarGroup size="sm" users={sortedUsers} limit={5} stacked showAdditionalCount popoverDetails={UserTooltip} />
  );
};

export default WorkspacePresenceUsers;
